/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';
import { enableSentry } from './sentry';

bootstrapApplication(AppComponent, appConfig);

// GTM code snippet
const script = document.createElement('script');
const noscript = document.createElement('noscript');
if (environment.production) {
  script.src = `/assets/_js/gtm-prod.js`;
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W8XB4MN2"></iframe>`;
} else if (enableSentry) {
  script.src = `/assets/_js/gtm-dev.js`;
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KP9H44JM"></iframe>`;
}
document.head.appendChild(script);
document.body.prepend(noscript);

// Image Optimisation
const hostPreconnect = document.createElement('link');
hostPreconnect.rel = 'preconnect';
hostPreconnect.href = globalThis.location.origin;
document.head.appendChild(hostPreconnect);

// Sentry
if (enableSentry) {
  const sentryConfig = environment.sentry;
  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: environment.name,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1,
    tracePropagationTargets: sentryConfig.tracePropagationTargets,
    // Session Replay
    replaysSessionSampleRate: sentryConfig.replaysSessionSampleRate,
    replaysOnErrorSampleRate: 1,
  });
}
